// @flow
import * as React from 'react';
import { withRouter } from 'speed-js-react';
import SidePaneContext from 'esm-web-pro/components/layout/context/SidePaneContext';
import BaseEditor from 'esm-web-pro/containers/map/editor/BaseEditor';

type Props = {
    editor: BaseEditor,
    children: any,
    match: Object,
}


class SidePaneMapLayerContainer extends React.Component<Props> {
    static contextType = SidePaneContext;

    componentDidUpdate(prevProps: Props) {
        const { match } = this.props;

        if (match.url && prevProps.match.url) {
            if (match.url !== prevProps.match.url) {
                this.context.togglePanel(false);
            }
        }
    }

    componentWillUnmount() {
        const { editor } = this.props;
        editor.setState({ focusedLayer: null });
    }

    render() {
        const { children } = this.props;

        return children;
    }
}

export default withRouter(SidePaneMapLayerContainer);
